import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const MobileNav = () => {
  const { user } = useAuth();
  const role = user?.role;

  const allNavItems = [
    { path: '/', label: 'Home', icon: 'dashboard', roles: ['admin', 'manager', 'tech'] },
    { path: '/customers', label: 'Customers', icon: 'people', roles: ['admin', 'manager', 'tech'] },
    { path: '/appointments', label: 'Schedule', icon: 'calendar', roles: ['admin', 'manager', 'tech'] },
    { path: '/invoices', label: 'Invoices', icon: 'receipt', roles: ['admin', 'manager', 'tech'] },
    { path: '/quotes', label: 'Quotes', icon: 'quote', roles: ['admin', 'manager', 'tech'] },
    { path: '/services', label: 'Services', icon: 'car', roles: ['admin', 'manager', 'tech'] },
    { path: '/mileage', label: 'Mileage', icon: 'mileage', roles: ['admin', 'manager', 'tech'] },
    { path: '/order-form', label: 'Orders', icon: 'orderform', roles: ['admin', 'manager', 'tech'] },
    { path: '/callback-list', label: 'Callbacks', icon: 'callback', roles: ['admin', 'manager', 'tech'] },
    { path: '/financials', label: 'Financials', icon: 'financials', roles: ['admin'] },
    { path: '/users', label: 'Users', icon: 'users', roles: ['admin'] },
    { path: '/settings', label: 'Settings', icon: 'settings', roles: ['admin'] },
    { path: '/trash', label: 'Trash', icon: 'trash', roles: ['admin', 'manager'] },
  ];

  const navItems = allNavItems.filter(item => {
    if (!role) return false;
    // Financials can be granted to a specific user regardless of role, not just admins
    if (item.path === '/financials') return role === 'admin' || !!user?.can_view_financials;
    return item.roles.includes(role);
  });

  const getIcon = (name) => {
    const icons = {
      dashboard: (
        <svg className="mobile-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="7" height="9" rx="1" />
          <rect x="14" y="3" width="7" height="5" rx="1" />
          <rect x="14" y="12" width="7" height="9" rx="1" />
          <rect x="3" y="16" width="7" height="5" rx="1" />
        </svg>
      ),
      people: (
        <svg className="mobile-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      calendar: (
        <svg className="mobile-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      ),
      receipt: (
        <svg className="mobile-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M4 2v20l3-2 3 2 3-2 3 2 3-2 3 2V2l-3 2-3-2-3 2-3-2-3 2-3-2z" />
          <path d="M8 10h8" />
          <path d="M8 14h4" />
        </svg>
      ),
      car: (
        <svg className="mobile-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M5 17h14v-5l-2-5H7l-2 5v5z" />
          <circle cx="7.5" cy="17.5" r="1.5" />
          <circle cx="16.5" cy="17.5" r="1.5" />
          <path d="M5 12h14" />
        </svg>
      ),
      mileage: (
        <svg className="mobile-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      ),
      quote: (
        <svg className="mobile-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <path d="M9.5 14.5c0-1 .8-1.5 1.8-1.5h1.4c1 0 1.8.5 1.8 1.4 0 .8-.6 1.2-1.4 1.4l-1.6.4c-.9.2-1.5.7-1.5 1.5 0 .9.8 1.4 1.8 1.4h1.4c1 0 1.8-.5 1.8-1.5" />
          <line x1="12" y1="12" x2="12" y2="13" />
          <line x1="12" y1="19" x2="12" y2="20" />
        </svg>
      ),
      orderform: (
        <svg className="mobile-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
          <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
          <line x1="9" y1="12" x2="15" y2="12" />
          <line x1="9" y1="16" x2="13" y2="16" />
          <polyline points="9 8 10 9 12 7" />
        </svg>
      ),
      callback: (
        <svg className="mobile-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
          <path d="M14 3l3 3-3 3" />
          <path d="M17 6h-6" />
        </svg>
      ),
      financials: (
        <svg className="mobile-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="12" y1="1" x2="12" y2="23" />
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
      ),
      users: (
        <svg className="mobile-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      settings: (
        <svg className="mobile-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
      ),
      trash: (
        <svg className="mobile-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="3 6 5 6 21 6" />
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          <line x1="10" y1="11" x2="10" y2="17" />
          <line x1="14" y1="11" x2="14" y2="17" />
        </svg>
      ),
    };
    return icons[name];
  };

  return (
    <nav className="mobile-nav">
      <ul className="mobile-nav__list">
        {navItems.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              className={({ isActive }) =>
                `mobile-nav__link ${isActive ? 'mobile-nav__link--active' : ''}`
              }
              end={item.path === '/'}
            >
              {getIcon(item.icon)}
              <span>{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default MobileNav;
